import { Cell } from '@ton/core/dist/boc/Cell';
import { hexToBase64 } from '../hexToBase64';

export function parsingTonTxPayload(payloadHex: string) {
  const cell = Cell.fromBase64(hexToBase64(payloadHex));
  const slice = cell.beginParse();
  const operationCode = slice.loadUint(32);
  const queryId = slice.loadUintBig(64);
  const amount = slice.loadCoins();
  const destination = slice.loadAddress();

  return {
    operationCode,
    queryId,
    amount,
    destination,
  };
}

export async function getJettonMinterAddress(userAddress) {
  const ton = await import('@ton/ton');
  const client = new ton.TonClient({
    endpoint: 'https://toncenter.com/api/v2/jsonRPC',
  });
  try {
    const result = await client.runMethod(userAddress, 'get_wallet_data');
    const slice = (result.stack as any).items[2].cell.beginParse();
    const minterAddress = slice.loadAddress();

    return minterAddress;
  } catch (error) {
    console.error('Can not get Jetton Minter Address:', error);
    return '';
  }
}
